import { useRef, useState, useEffect } from "react";
const usePseudoClasses = (ref) => {
  const refObject = ref ? ref : useRef(null);
  const [isHovered, setIsHovered] = useState(false);
  const [isFocused, setIsFocused] = useState(false);
  const [isActive, setIsActive] = useState(false);
  useEffect(() => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _i;
    const handleMouseEnter = () => setIsHovered(true);
    const handleMouseLeave = () => setIsHovered(false);
    const handleFocusIn = () => setIsFocused(true);
    const handleFocusOut = () => setIsFocused(false);
    const handlePointerDown = () => setIsActive(true);
    const handlePointerUp = () => setIsActive(false);
    const handlePointerLeave = () => setIsActive(false);
    (_a = refObject.current) == null ? void 0 : _a.addEventListener("mouseenter", handleMouseEnter);
    (_b = refObject.current) == null ? void 0 : _b.addEventListener("mouseleave", handleMouseLeave);
    (_c = refObject.current) == null ? void 0 : _c.addEventListener("pointerenter", handleMouseEnter);
    (_d = refObject.current) == null ? void 0 : _d.addEventListener("pointerleave", handleMouseLeave);
    (_e = refObject.current) == null ? void 0 : _e.addEventListener("focusin", handleFocusIn);
    (_f = refObject.current) == null ? void 0 : _f.addEventListener("focusout", handleFocusOut);
    (_g = refObject.current) == null ? void 0 : _g.addEventListener("pointerdown", handlePointerDown);
    (_h = refObject.current) == null ? void 0 : _h.addEventListener("pointerup", handlePointerUp);
    (_i = refObject.current) == null ? void 0 : _i.addEventListener("pointerleave", handlePointerLeave);
    return () => {
      var _a2, _b2, _c2, _d2, _e2, _f2, _g2, _h2, _i2;
      (_a2 = refObject.current) == null ? void 0 : _a2.removeEventListener("mouseenter", handleMouseEnter);
      (_b2 = refObject.current) == null ? void 0 : _b2.removeEventListener("mouseleave", handleMouseLeave);
      (_c2 = refObject.current) == null ? void 0 : _c2.removeEventListener("pointerenter", handleMouseEnter);
      (_d2 = refObject.current) == null ? void 0 : _d2.removeEventListener("pointerleave", handleMouseLeave);
      (_e2 = refObject.current) == null ? void 0 : _e2.removeEventListener("focusin", handleFocusIn);
      (_f2 = refObject.current) == null ? void 0 : _f2.removeEventListener("focusout", handleFocusOut);
      (_g2 = refObject.current) == null ? void 0 : _g2.removeEventListener("pointerdown", handlePointerDown);
      (_h2 = refObject.current) == null ? void 0 : _h2.removeEventListener("pointerup", handlePointerUp);
      (_i2 = refObject.current) == null ? void 0 : _i2.removeEventListener("pointerleave", handlePointerLeave);
    };
  }, [refObject]);
  return { refObject, isHovered, isFocused, isActive };
};
export {
  usePseudoClasses
};
//# sourceMappingURL=usePseudoClasses.js.map
